<template>
  <footer class="app-footer">
    <div class="footer-top">
      <div class="footer-column">
        <h3>Promo</h3>
        <ul>
          <li><a href="#">Welcome package</a></li>
          <li><a href="#">Wednesday bonus</a></li>
          <li><a href="#">Reload bonus</a></li>
        </ul>
      </div>

      <div class="footer-column">
        <h3>Info</h3>
        <ul>
          <li><a href="#">T&amp;C</a></li>
          <li><a href="#">Bonus terms</a></li>
          <li><a href="#">Payment methods</a></li>
          <li><a href="#">Privacy Policy</a></li>
          <li><a href="#">Responsible Gaming</a></li>
        </ul>
      </div>

      <div class="footer-column">
        <h3>Help</h3>
        <ul>
          <li><a href="#">F.A.Q</a></li>
          <li><a href="#">Contact us</a></li>
          <li><a href="#">Support</a></li>
        </ul>
      </div>

      <div class="footer-column footer-gaming">
        <h3>Responsible Gaming</h3>
        <div class="gaming-icons">
          <img src="/footer/Vector.svg" alt="18+" />
          <img src="/footer/trust-icons-2.svg" alt="PerunPlay" />
          <img src="/footer/gamblers_anonymous%201.svg" alt="Gamblers Anonymous" />
          <img src="/footer/gamcare%201.svg" alt="GamCare" />
        </div>
      </div>
    </div>

    <div class="footer-divider"></div>

    <div class="footer-payments">
      <img src="/footer/payments-1.svg" alt="Bitcoin" />
      <img src="/footer/payments-2.svg" alt="Ethereum" />
      <img src="/footer/payments-3.svg" alt="Litecoin" />
      <img src="/footer/payments-4.svg" alt="Tether" />
    </div>

    <div class="footer-about">
      <p>
        N-brand.io is owned and operated by Company registered and established under the laws of Curaçao.
        Company is licensed and regulated by Antillephone N.V. It is the player's sole responsibility to inquire
        about the existing laws and regulations of the given jurisdiction for online gambling. Company is
        officially registered by the Government of Curaçao as an Information Provider, legally authorized to
        conduct online gaming operations from Curaçao. Remote gaming licensing and supervision is provided by
        Antillephone N.V. All payments with Paysafe are made via Company.
      </p>
    </div>

    <div class="footer-legal">
      <p>© 2022 N-brand.io | All Rights Reserved.</p>
      <img src="/footer/trust-icons-1.svg" alt="Responsible Gaming" />
    </div>
  </footer>
</template>

<style scoped>
.app-footer {
  padding: 48px 24px 32px;
  background: var(--color-footer-bg);
  color: #fff;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
}

.footer-top {
  display: grid;
  gap: 32px;
  grid-template-columns: repeat(1, minmax(0, 1fr));
}

.footer-column h3 {
  margin: 0 0 20px;
  font-size: 1rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.footer-column ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footer-column li {
  margin-bottom: 12px;
}

.footer-column a {
  color: rgba(255, 255, 255, 0.8);
  transition: color 0.2s ease;
}

.footer-column a:hover {
  color: var(--color-accent);
}

.footer-gaming .gaming-icons {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  align-items: center;
  justify-content: flex-start;
}

.footer-gaming img {
  max-height: 38px;
  width: auto;
  display: block;
}

.footer-divider {
  margin: 40px 0;
  height: 1px;
  background: rgba(255, 255, 255, 0.08);
}

.footer-payments {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 24px;
  margin-bottom: 32px;
}

.footer-payments img {
  max-height: 34px;
  width: auto;
  filter: brightness(1.1);
}

.footer-about p {
  margin: 0 auto 24px;
  max-width: 1000px;
  line-height: 1.75;
  color: rgba(255, 255, 255, 0.74);
  font-size: 0.95rem;
}

.footer-legal {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 18px;
  font-size: 0.95rem;
  color: rgba(255, 255, 255, 0.7);
}

.footer-legal img {
  max-height: 28px;
  width: auto;
}

@media (min-width: 768px) {
  .app-footer {
    padding-left: calc(var(--app-sidebar-width) + 24px);
  }

  .footer-top {
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 32px;
  }

  .footer-gaming {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-self: end;
    text-align: right;
  }

  .footer-gaming .gaming-icons {
    justify-content: flex-end;
  }

  .footer-payments {
    gap: 28px;
  }

  .footer-about p {
    margin-bottom: 40px;
  }
}
</style>
